import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { UserCheckIcon, ShieldCheckIcon, MessageSquareIcon, CheckCircleIcon } from 'lucide-react';
export function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const features = [{
    icon: UserCheckIcon,
    title: 'Personalized Care Plans',
    description: "We don't believe in one-size-fits-all. Every patient receives a tailored care plan designed to meet their unique medical goals and personal preferences."
  }, {
    icon: ShieldCheckIcon,
    title: 'A Commitment to Safety & Comfort',
    description: 'Our care is designed to be a warm, welcoming, and secure in the comfort of your home to promote healing and maintains your dignity.'
  }, {
    icon: MessageSquareIcon,
    title: 'Transparent Communication',
    description: "We believe families are partners in care. We maintain open, honest communication so you are always informed about your loved one's progress."
  }];
  return <section className="py-20 bg-white overflow-hidden" data-id="element-351">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-352">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-353">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-354">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-355">
              Why Choose Edvin Home Health Care Solutions
            </h2>
            <div className="w-20 h-1.5 bg-secondary mx-auto mb-8 rounded-full" data-id="element-356"></div>
            <p className="text-lg text-dark-muted leading-relaxed" data-id="element-357">
              Choosing the right care is a deeply personal and significant
              decision. At Edvin Home Health Care Solutions, we combine
              high-level clinical expertise with a person-centered approach to
              ensure every patient feels safe, respected, and empowered 24/7.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-358">
            {features.map((feature, idx) => <div key={idx} className="relative bg-light-alt rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group" data-id="element-359">
                <div className="bg-primary/10 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary transition-colors duration-300" data-id="element-360">
                  <feature.icon className="h-8 w-8 text-primary group-hover:text-white transition-colors duration-300" data-id="element-361" />
                </div>
                <h3 className="text-xl font-bold text-dark mb-4" data-id="element-362">
                  {feature.title}
                </h3>
                <p className="text-dark-muted leading-relaxed text-sm lg:text-base" data-id="element-363">
                  {feature.description}
                </p>
                <div className="mt-6 flex items-center text-primary font-bold text-sm" data-id="element-364">
                  <CheckCircleIcon className="h-4 w-4 mr-2" data-id="element-365" />
                  <span data-id="element-366">Quality Guaranteed</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}